import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import CheckCSName from "../CheckCSName";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultBody from "../../../components/table/ResultBody";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import {useUser} from "../../../context/UserContext";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultView from "../../../components/ResultView";

export function XY8({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const print_value = (value, decimalPlaces) => {
    if (typeof value === 'number') {
        return value.toFixed(decimalPlaces)
    } else {
        return value
    }
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XY15.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences at Overbank DS Reach Lengths between Assigned (at Cross Section Data) and Calculated using the Schematic XY values. The cross sections with a difference more than {settings?.thresholds?.overbank_dsrl_tol}% are listed in the table below.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left'}}></ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center'}} colSpan={6}>Overbank DS Reach Length (ft)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'left', width: HecRasHelper.getWidth(15)}}>
                                    River Station
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    LOB Assigned
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    LOB Estimated
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    % Diff
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    ROB Assigned
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    ROB Estimated
                                </ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                    % Diff
                                </ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>

                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{print_value(r.lob, settings['decimalPlaces']['reach_channel'])}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{print_value(r.left_schematic, 0)}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{print_value(r.left_percent, 0)}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{print_value(r.rob, settings['decimalPlaces']['reach_channel'])}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {
                                                print_value(r.right_schematic, 0)
                                            }
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{ textAlign: 'right' }}>{print_value(r.right_percent, 0)}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>

                    {
                        row?.data?.find(r => r.right_percent === 'N/A' || r.left_percent === 'N/A') && (
                            <ResultText style={{marginTop: '10px', fontStyle: 'italic'}}>
                                <b>N/A:</b> % Diff is calculated as (Assigned - Estimated)/Estimated * 100%. If Estimated value is zero, % Diff will be shown as N/A.
                            </ResultText>
                        )
                    }
                </>
            )
        }
        default: {
            return (
                <ResultText>
                    {row?.message}
                </ResultText>
            )
        }
    }
}